<div
  class="bp-value-change"
	[ngClass]="{
		'color-positive': value > 0,
		'color-negative': value < 0,
		'color-neutral': value === 0
	}"
  hidePortfolioValue
  [isHideActive]="isPortfolioValueHidden">
  @if (showArrows) {
    <span class="change-arrow"></span>
  }
  <span class="content">
    <ng-content></ng-content>
  </span>
</div>
